import {
  FieldValues,
  UseControllerProps,
  useController
} from "react-hook-form";

import FaxIcon from "@mui/icons-material/Fax";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import type { SxProps } from "@mui/material/styles";

type FaxNumberFieldProps = {
  label: string;
  required?: boolean;
  sx?: SxProps;
};

export type RhfFaxNumberFieldProps<T extends FieldValues> =
  FaxNumberFieldProps & UseControllerProps<T>;

const normalizeFaxNumber = (value: string) => value.replace(/\D/g, ""); // Remove all non-digit characters

export default function FaxNumberField<T extends FieldValues>({
  name,
  label,
  required,
  sx,
  control
}: RhfFaxNumberFieldProps<T>) {
  const { field } = useController({
    name,
    control,
    rules: {
      required: required ? `${label} is required` : false,
      pattern: {
        value: /^(?:\d{10}|\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4})$/,
        message: `${label} must be exactly 10 digits.`
      }
    }
  });
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      sx={sx}
    >
      <FaxIcon sx={{ mt: 0.5, mr: 1.5 }} />

      <TextField
        fullWidth
        label={label}
        required={required}
        {...field}
        onChange={(e) => field.onChange(normalizeFaxNumber(e.target.value))}
      />
    </Box>
  );
}
